<template>
  <div class="instruction-template" id="instruction-template">
    <div class="header">
      <img src="@/assets/png/logo.png" class="logo" />
      <h1 class="container-no">{{ shortContainerNo }}</h1>
      <div class="title-container">
        <h1 class="title">Unloading Job - {{ jobNo }}</h1>
      </div>
      <div class="page-container">
        <h2 class="page">{{ currentPage }}/{{ pageCount }}</h2>
      </div>
      <img id="qrcode" :src="src" />
    </div>

    <div class="basic-info-container">
      <el-row class="basic-info">
        <el-col
          :span="6"
          v-for="(item, index) in basicInfo"
          :key="'basic-info-item-' + index"
          class="grid-content-container"
          ><span>{{ item.label }}:{{ item.value }}</span></el-col
        >
      </el-row>
    </div>

    <div class="content-container">
      <el-row>
        <el-col
          v-for="(item, index) in groups.slice(0, 3)"
          :key="'col-' + index"
          :span="8"
          :class="'col-' + index"
        >
          <unloading-instruction-section
            :group-name="item.groupName"
            :goods-cnt="item.cnt"
            :group-note="item.note"
            class="group"
          ></unloading-instruction-section>
          <div class="divider"></div>
        </el-col>
      </el-row>
      <el-row v-if="groups.length > 3">
        <el-col
          v-for="(item, index) in groups.slice(3, 6)"
          :key="'col-' + index"
          :span="8"
          :class="'col-' + index"
        >
          <unloading-instruction-section
            :group-name="item.groupName"
            :goods-cnt="item.cnt"
            :group-note="item.note"
            class="group"
          ></unloading-instruction-section>
          <div class="divider"></div>
        </el-col>
      </el-row>
      <div v-else class="empty-row"></div>
    </div>
  </div>
</template>

<script>
// components
import UnloadingInstructionSection from '@/components/jobs/UnloadingInstructionSection.vue'
import QRCode from 'qrcode'

export default {
  props: {
    basicInfo: {
      type: Array,
      required: true
    },
    qrCodeInfo: {
      type: Object,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    },
    shortContainerNo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      src: ''
    }
  },
  components: { UnloadingInstructionSection },
  methods: {
    async getSrc() {
      this.src = await QRCode.toDataURL(JSON.stringify(this.qrCodeInfo))
    }
  },
  computed: {
    jobNo() {
      return this.qrCodeInfo.jobNo
    }
  },
  mounted() {
    this.getSrc()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.instruction-template {
  background-color: #fff;
  .header {
    @extend .remove-bottom-border;
    @extend .f-r-c-c;
    @extend .f-r-hsb;
    position: relative;
    padding: 0 10px;
    .logo {
      height: 50px;
    }
    .container-no {
      position: absolute;
      left: 10%;
    }
    .title-container {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      .title {
        margin: 0;
      }
    }
    .page-container {
      position: absolute;
      right: 30%;
    }
    .page {
      margin: 0;
    }
  }
  .basic-info-container {
    height: 40px;

    .basic-info {
      border: solid;
      font-size: 26px;
      font-weight: bold;
      height: 100%;

      .grid-content-container {
        @extend .f-r-c-c;
        border-right: solid;
        height: 100%;
        overflow: hidden;

        // &:last-child {
        //   border: none;
        //   font-size: 18px;
        // }
      }
    }
  }

  .content-container {
    width: 100%;
    .el-row {
      width: 100%;
      height: 100%;
      @extend .f-r;
      .el-col {
        height: 100%;
        @extend .f-r;
        flex-grow: 1;
        .group {
          height: 100%;
          border-left: none;
          border-right: none;
        }
        .divider {
          width: 4px;
          background-color: black;
        }
      }
      div[class$='col-0'] {
        border-left: solid;
      }
    }
  }
}

.empty-row {
  height: 412px;
}
#qrcode {
  height: 130px;
  width: 150px;
}
@media print {
  @page {
    margin: 0;
    background-color: red;
  }
}
</style>
